module.exports = __webpack_public_path__ + "media/images/icons/icon-sneaker-65c48c2729ae8a7235edcb4e4b28c6ae.svg";